import { WebStoragesKeys } from '@/shared/enums/webStorages';

export class ApiConfigAccessor {
  private cache: { rawValue: string; parsedData: unknown } | null = null;
  private readonly key = WebStoragesKeys.API_CONFIG;

  getConfig(): AppConfig | null {
    const rawValue = sessionStorage.getItem(this.key);

    if (!rawValue || rawValue === 'undefined' || rawValue === 'null') {
      this.cache = null;
      return null;
    }

    if (this.cache && this.cache.rawValue === rawValue) {
      return this.cache.parsedData as AppConfig;
    }

    const parsedData = JSON.parse(rawValue);
    this.cache = { rawValue, parsedData };

    return parsedData;
  }

  setConfig(config: AppConfig) {
    const serialized = JSON.stringify(config);
    sessionStorage.setItem(this.key, serialized);
    this.cache = { rawValue: serialized, parsedData: config };
  }
}

export const apiConfigAccessor = new ApiConfigAccessor();
